import store from 'store';

function checkRoutePermissions (targetRoute) {
  const matchedPath = targetRoute.matched;
  const currentAccount = store.getters['accounts/currentAccount'];

  // if not account route - it has not permissions
  if (!currentAccount) {
    return true;
  }
  const accountType = currentAccount.type;

  return matchedPath.every(r => {
    let hasPermissions = true;
    let hasComponents = true;
    let allowedForAccountType = true;

    let routePermissions = r.meta.permissions;
    let routeComponents = r.meta.components;

    const onlyUsual = r.meta.onlyUsualAccount || false;
    const onlyMCC = r.meta.onlyMCCAccount || false;

    // permission can be function that returns permission based on store state
    if (typeof routePermissions === 'function') {
      routePermissions = routePermissions(store);
    }

    if (routePermissions) {
      hasPermissions = store.getters['user/canUser'](routePermissions);
    }

    if (routeComponents) {
      hasComponents = store.getters['accounts/hasComponent'](routeComponents);
    }

    if (onlyMCC) {
      allowedForAccountType = accountType === 'MCC';
    }

    if (onlyUsual) {
      allowedForAccountType = accountType === 'USUAL';
    }

    return hasPermissions && hasComponents && allowedForAccountType;
  });
}

export default checkRoutePermissions;
